module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_agro_industria.25ce234f.jpg";